import InfoModal from '../../../common/InfoModal'
import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'

const EditDisabledModal = (props) => (
  <InfoModal
    title='You Can&apos;t Edit This Package'
    icon={<WarningIcon />}
    buttonMessage='Got it'
    {...props}
  >
    <div>
      <p>
        This pricing package already has enrollments attached to it. To ensure clean and reliable reporting (now and in the future),
        packages with enrollments are locked from editing.
      </p>
      <h5 className='font-weight-bold'>What should I do instead?</h5>
      <p>
        The best practice is to archive this package and create a new one with your updated details.
      </p>
    </div>
  </InfoModal>
)

export default EditDisabledModal
